import { render, staticRenderFns } from "./LandingSocialInfo.vue?vue&type=template&id=43577840&scoped=true&"
import script from "./LandingSocialInfo.vue?vue&type=script&lang=js&"
export * from "./LandingSocialInfo.vue?vue&type=script&lang=js&"
import style0 from "./LandingSocialInfo.vue?vue&type=style&index=0&id=43577840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43577840",
  null
  
)

/* custom blocks */
import block0 from "./LandingSocialInfo.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./LandingSocialInfo.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
